export default {"src":"/_next/static/media/sunnova.7d803e7d.svg","height":80,"width":180,"blurWidth":0,"blurHeight":0};